import { component } from 'picoapp';

export default component(async (node) => {
  const { height } = node.getBoundingClientRect();
  const root = document.documentElement;

  root.style.setProperty('--announcement-bar-height', `${height}px`);
});
